module.exports = {"placeholder":"vyhľadávacie pole","searchAutocompleteTitle":"História vyhľadávania:"}